import type { ComponentStatus, WearSection, WearStatus } from './types';

export const TEST_ID = 'droneComponentsTab';

export const SECTION_SKELETON_LINES = 8;

export const SINGLE_UNIT_COUNT = 1;

export const WEAR_SECTIONS: WearSection[] = [
    { partType: 'MOTOR', titleKey: 'motors' },
    { partType: 'PROPELLER_SET', titleKey: 'propellers' },
    { partType: 'PUMP', titleKey: 'pumps' },
    { partType: 'FLOW_METER', titleKey: 'flowMeter' }
];

export const COMPONENT_STATUS_BY_WEAR_STATUS: Record<WearStatus, ComponentStatus> = {
    DUE: 'DUE',
    NOT_CONFIGURED: 'NOT_REPORTED',
    OK: 'OK'
};
